import actionCreatorFactory from 'typescript-fsa'

import { ErrorResponse } from '~api/models'
import { Toast } from '~shared/models/Toast'

import { BootstrapData } from './reducer'

const actionCreator = actionCreatorFactory('GLOBAL')

/**
 * Actions
 */
export const initApp = actionCreator.async<void, BootstrapData, ErrorResponse>('INIT_APP')

export const addToastToBeDisplayed = actionCreator<Toast>('ADD_TOAST_TO_BE_DISPLAYED')
export const toastDisplayed = actionCreator<{toastKey: string}>('TOAST_DISPLAYED')
